import { render, staticRenderFns } from "./CartProductVariant.vue?vue&type=template&id=8f04e368&"
import script from "./CartProductVariant.vue?vue&type=script&lang=js&"
export * from "./CartProductVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports